// extracted by mini-css-extract-plugin
export default {"cancelBtn":"confirmDeleteTask_cancelBtn__OR8sP","deleteBtn":"confirmDeleteTask_deleteBtn__4FZxF"};